<div class="notification-settings-dialog" [class.embedded]="embedded()">
  <p-toast></p-toast>

  <h3 class="dialog-title">Preferencias de notificaci&#xF3;n</h3>
  <p class="dialog-description">
    Selecciona qu&#xE9; tipos de notificaciones deseas recibir. Los cambios se aplican de inmediato.
  </p>

  @if (loading()) {
    <div class="loading-state">
      <p-progressSpinner strokeWidth="4" [style]="{ width: '40px', height: '40px' }"></p-progressSpinner>
    </div>
  } @else {
    <div class="preferences-list">
      @for (group of preferenceGroups(); track group.module) {
        <section class="preference-group">
          <div class="preference-group-header">
            <i [class]="group.icon" aria-hidden="true"></i>
            <span class="preference-group-title">{{ group.label }}</span>
          </div>
          <div class="preference-group-items">
            @for (pref of group.preferences; track pref.kind) {
              <div class="preference-item">
                <div class="preference-info">
                  <span class="preference-label">{{ pref.label }}</span>
                </div>
                <mat-slide-toggle
                  [checked]="pref.enabled"
                  (change)="onToggle(pref, $event.checked)"
                  [disabled]="saving()"
                  [attr.aria-label]="'Notificacion ' + pref.label"
                  color="primary">
                </mat-slide-toggle>
              </div>
            }
          </div>
        </section>
      }
    </div>
  }

  @if (!embedded()) {
    <div class="dialog-footer">
      <button pButton type="button" label="Cerrar" icon="pi pi-times" class="p-button-outlined" (click)="close()" [disabled]="saving()"></button>
    </div>
  }
</div>
